<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <p class="letra10" v-for="coordinador in data.item.asignaciones" :key="data.item.pti + coordinador.nombreCoordinador" 
    :value="coordinador.nombreCoordinador">
            {{ coordinador.nombreCoordinador}} <br/>
        <b-button variant="outline-danger"  @click="putInactivarAsignacion(coordinador.idPtiAltoRiesgoCoordinador)" size="sm"  v-if="$localStorageService.can('DX_14_inactiva_asignacion')">
            <i class="fa fa-trash-o"  aria-hidden="true">
        </i> 
        </b-button> 
    </p>
</div> 
</template>

<script>
export default {
    name: "BandejaAsignacionesComponente",
    props: {
        data: Object,
        resource: Object
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }),
    created(){
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
      
        putInactivarAsignacion(idPtiAltoRiesgoCoordinador){
 
            this.$http
                .put(
                    this.$api +
                    "ptialtoriesgo/inactivarAsignacion/" + idPtiAltoRiesgoCoordinador + "/" + this.$localStorageService.getIdUsuario()
                )
                .then((response) => { 
                    this.$swal.fire({
                        icon: 'success',
                        title: response.data.message
                    });
                })
                .catch((error) => {
                    this.$swal.fire({
                        icon: "error",
                        title: "Ocurrio un error",
                        text: error.message,
                    });
                }) ;
                this.$emit("_funcionExtra", 1);
        }
    }
}
</script>
